// import { BonnySubscription } from '../api/types';

export const getTrialPeriod = (): number => 14; // (subscription === null ? 14 : 0);
